import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export default function ProcessTimeline({ t }) {
    return (
        <section id="proces" className="border-t border-white/5 px-5 sm:px-8 py-24 sm:py-28">
            <div className="mx-auto max-w-6xl">
                <motion.div
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.7, ease: EASE }}
                    className="mb-14"
                >
                    <p className="flex items-center gap-4 font-mono text-[11px] uppercase tracking-[0.3em] text-glacier">
                        <span className="inline-block h-px w-10 bg-glacier/60" />
                        {t.process.overline}
                    </p>
                    <h2 className="mt-5 font-display text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight">
                        {t.process.title}
                    </h2>
                </motion.div>

                <div data-testid="process-timeline-container" className="grid gap-px overflow-hidden rounded-lg border border-white/10 bg-white/10 md:grid-cols-2 lg:grid-cols-4">
                    {t.process.steps.map((step, i) => (
                        <motion.div
                            key={step.num}
                            data-testid="process-step-item"
                            initial={{ opacity: 0, y: 28 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.6, delay: i * 0.1, ease: EASE }}
                            className="group relative bg-coal p-8 transition-colors duration-500 hover:bg-[#1A1F25]"
                        >
                            <span className="font-display text-4xl font-medium text-glacier/50">{step.num}</span>
                            <h3 className="mt-5 font-display text-lg font-medium tracking-tight text-ivory">
                                {step.title}
                            </h3>
                            <p className="mt-2.5 text-sm leading-relaxed text-fog">{step.text}</p>
                            <div className="absolute bottom-0 left-0 h-px w-0 bg-glacier transition-[width] duration-700 group-hover:w-full" />
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
